import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TopNavbarComponent } from '@app/shared/components/top-navbar/top-navbar.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LoyaltyClubHeaderComponent } from '@app/shared/components/loyalty-club-header/loyalty-club-header.component';
import { ConsentFormComponent } from '@app/+profile-form/components/consent-form/consent-form.component';
import { LoyaltyClubFooterComponent } from '@app/shared/components/loyalty-club-footer/loyalty-club-footer.component';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TopNavbarComponent,
    TranslatePipe,
    LoyaltyClubHeaderComponent,
    ConsentFormComponent,
    LoyaltyClubFooterComponent,
  ],
})
export class ConsentComponent {
}
